import { Container } from "@material-ui/core";
import { Close, FiberManualRecord } from "@material-ui/icons";
import {
  AppBar,
  Box,
  Grid,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import CardSkeleton from "./Components/CardSkeleton";
import moment from "moment-timezone";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { globalStyles } from "styles";
import { formatDate } from "utils";
import { optionsNewsType } from "./Components/Contants";

const PreviewNewsAds = ({ userLogin }) => {
  const classes = globalStyles();
  const history = useHistory();
  const { newsAds } = useSelector(data => data);
  const typeWeb = localStorage.getItem("typeWeb");
  const publisher_name = userLogin?.publisher?.name;
  const role_name = userLogin?.name;
  const date = formatDate(moment());
  const isMpis = typeWeb === "mpis";

  const [payload, setPayload] = useState({
    title: "",
    type: "",
    banner_image: null,
  });
  const { title, type, banner_image } = payload;
  const mockfieldSubTitle = isMpis
    ? [{ text: role_name, isUser: true }, { text: date }]
    : [{ text: publisher_name }, { text: date }, { text: type }];

  useEffect(() => {
    setPayload({
      title: newsAds?.title || "Title",
      type:
        optionsNewsType.find(item => item.key === newsAds?.type)?.label ||
        "News & Ads",
      banner_image: newsAds?.banner_image,
    });
    document.getElementById("contentAsHTML").innerHTML = newsAds?.content;
  }, [newsAds]);

  return (
    <Box p="42px 0 24px">
      <PreviewAppBar>
        <Grid container columnSpacing={2}>
          <Grid item>
            <IconButton onClick={() => history.goBack()}>
              <Close />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography fontSize={25}>Preview</Typography>
          </Grid>
        </Grid>
      </PreviewAppBar>
      <Container>
        <Grid container columnSpacing={3}>
          <Grid item xs={8}>
            <Typography fontSize={40} fontWeight={600} lineHeight={1}>
              {title}
            </Typography>
            <Grid container spacing={1} my="16px" alignItems="center">
              {mockfieldSubTitle.map(({ text, isUser }, index) => (
                <Fragment key={index}>
                  <Grid item>
                    <Typography
                      fontSize={20}
                      fontWeight={isUser ? 500 : 400}
                      color={isUser ? "black" : "#8F8F8F"}
                    >
                      {text}
                    </Typography>
                  </Grid>
                  {index < mockfieldSubTitle.length - 1 && (
                    <Grid item>
                      <DotSeparator />
                    </Grid>
                  )}
                </Fragment>
              ))}
            </Grid>
            {banner_image && (
              <img
                alt="banner"
                src={banner_image}
                className={classes?.bannerImage}
              />
            )}
            <Typography mt="16px" fontSize={20} color="#687083">
              <Box id="contentAsHTML" />
            </Typography>
          </Grid>
          <Grid item xs={4}>
            {["EDUCATION", "TOP NEWS"].map(label => (
              <Box key={label} mb="16px">
                <Typography fontSize={20} color="#687083" fontWeight={700}>
                  {label}
                </Typography>
                <Grid container direction="column" rowSpacing={1} mt="8px">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <Grid item key={index}>
                      <CardSkeleton />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const PreviewAppBar = styled(AppBar)({
  backgroundColor: "#f5f5f5",
  color: "black",
  boxShadow: "none",
  borderBottom: "1px solid #e0e0e0",
  padding: "16px 24px",
});
const DotSeparator = styled(FiberManualRecord)({
  height: "8px",
  width: "8px",
  color: "#8F8F8F",
});

export default PreviewNewsAds;
